import {
  getTrainingDatesIndoor,
  getTrainingDatesOutdoor,
  showUntil,
} from '../components/Utils/TrainingDates';
import './NewsPage.css';

function NewsPage() {
  return (
    <div className="news-page">
      <h2>Aktuelles</h2>
      {showUntil(new Date('2026-09-19')) && (
        <>
          <h3>Saisionabschluss (Grillen) am Bootshaus</h3>
          <p>
            Am <b>19. September</b> möchten wir nach dem ersten
            Hallenbadtraining <b>(ab ca. 17 Uhr)</b> mit euch{' '}
            <b>am Bootshaus</b> zum Saisonabschluss grillen.
            <br />
            Baguette und Getränke sind vorhanden. Fleisch oder Grillalternativen
            bringt sich bitte jeder selbst mit. Salat und Kuchen/Dessert-Spenden
            sind willkommen.
            <br />
            Wir freuen uns auf euch. Bitte gibt in der WhatsApp Gruppe Bescheid
            ob Ihr kommt, damit wir besser planen können.
          </p>
        </>
      )}
      {showUntil(new Date('2026-03-15')) && (
        <>
          <h3>Aufräum- und Frühjahrputzaktion</h3>
          <p>
            Am Samstag den <b>14.03.2026</b> findet unsere{' '}
            <b>Aufräum- und Frühjahrputzaktion im Bootshaus</b> statt. Wir
            treffen uns um <b>9:00 Uhr am Bootshaus</b>. Für das leibliche Wohl
            ist gesorgt. <br />
            <b>
              Bringt bitte bis Samstag alles Leihmaterial zurück ins Bootshaus
              zur Inventarisierung oder gebt den Materialwarten bescheid!
            </b>
          </p>
        </>
      )}
      {showUntil(new Date('2025-12-13')) && (
        <>
          <h3>Weihnachtsfeier</h3>
          <p>
            Am <b>13. Dezember</b> möchten wir nach dem letzten Training für
            dieses Jahr <b>(ab ca. 17 Uhr)</b> mit euch <b>im Bootshaus</b> eine
            kleine Weihnachtsfeier veranstalten.
            <br />
            Wir freuen uns auf euch und würden uns sehr über Kuchen, Plätzchen,
            Lebkuchen oder ähnliche Spenden freuen.
          </p>
        </>
      )}
      {showUntil(new Date('2026-01-31')) && (
        <>
          <h3>Mitgliederversammlung mit Fahrtenplanung 2026</h3>
          <p>
            Die Mitgliederversammlung und Fahrtenplanung 2026 findet am Sonntag,
            den <b>01.02.2026 - ab 14:00 Uhr im Bootshaus</b> statt.
            <br />
            Die Einladung hierzu wurde bereits per E-Mail versendet.
            <br />
            <b>
              {' '}
              Solltest du keine E-Mail erhalten haben, sind eventuell deine
              Kontaktdaten nicht mehr aktuell oder der Verein hat noch keine
              E-Mail - Adesse von dir. Bitte melde dich in diesem Fall unter:{' '}
              <a href="mailto:vorstand@kanuverein-suew.de">
                mailto:vorstand@kanuverein-suew.de
              </a>
            </b>
            <br />
            <i>
              Können wir dich nicht per E-Mail zur Mitgleiderversammlung
              einladen, müssen wir dies per Post tuen. Hierdurch entstehen dem
              Verein zusätzlicher finanzieller und organisatorischer Aufwand.
            </i>
          </p>
        </>
      )}
      {getTrainingDatesOutdoor().length !== 0 && (
        <>
          <h3>Trainingsbetrieb (Sommer 2025)</h3>
          {/*<p>Auf Grund der anhaltenden technischen Probleme des Freibads des Rebmeerbad Bad Bergzabern <i>(Friedrich-Ebert-Straße 40, 76887 Bad Bergzabern)</i> findest das Training aktuell im Schwimmerbecken zu folgenden geänderten Zeiten statt: <b>wöchentlich Mittwoch von 19:30 - 20:30 Uhr statt. Treffpunkt ist 19:00 Uhr vor dem Eingang zum Freibad.</b></p>*/}
          <p>
            Das Freibadbadtraining im Rebmeerbad Bad Bergzabern
            (Friedrich-Ebert-Straße 40, 76887 Bad Bergzabern) findet{' '}
            <b>
              ab dem 03.06.2025 wieder jede Woche Dienstags von 19:00 - ca.
              20:30 Uhr statt. <u>Treffpunkt ist 19:00 Uhr</u> vor dem Eingang
              zum Freibad.
            </b>
            <br />
            Die nächsten Termine sind der <b>{getTrainingDatesOutdoor()}</b>
          </p>
        </>
      )}
      {getTrainingDatesIndoor().length !== 0 && (
        <>
          <h3>Trainingsbetrieb</h3>
          {/*<p>Auf Grund der anhaltenden technischen Probleme des Freibads des Rebmeerbad Bad Bergzabern <i>(Friedrich-Ebert-Straße 40, 76887 Bad Bergzabern)</i> findest das Training aktuell im Schwimmerbecken zu folgenden geänderten Zeiten statt: <b>wöchentlich Mittwoch von 19:30 - 20:30 Uhr statt. Treffpunkt ist 19:00 Uhr vor dem Eingang zum Freibad.</b></p>*/}
          <p>
            Das Hallenbadtraining im Rebmeerbad Bad Bergzabern
            (Friedrich-Ebert-Straße 40, 76887 Bad Bergzabern) findet aktuell{' '}
            <b>
              alle zwei Wochen Samstags von 15:00 - ca. 16:45 Uhr statt.{' '}
              <u>Treffpunkt ist 14:45 Uhr</u> vor dem Eingang zum Hallenbad.
            </b>
            <br />
            Die nächsten Termine sind der <b>{getTrainingDatesIndoor()}</b>
          </p>
        </>
      )}
      <h3>Spendenaktion für ein neues Wildwasserboot für die Kanu-Jugend</h3>
      <p>
        Mit Hilfe der Plattform Betterplace.org sammeln wir gerade für ein neues
        Wildwasserboot für unsere Jugend. Betterplace.org ermöglicht es
        transparent und sicher zu spenden. Zudem erhaltet ihr nach einer Spende
        von der Plattform direkt eine Spendenbescheinigung. Über eine Spende
        würden wir uns sehr freuen!
        <br />
        <a
          href="https://www.betterplace.org/de/projects/153811?utm_campaign=user_share&utm_medium=ppp_stats&utm_source=Link&utm_content=bp"
          target="_blank"
          rel="noreferrer"
        >
          Link zu Betterplace.org
        </a>
      </p>
    </div>
  );
}

export default NewsPage;
